module.exports = __webpack_public_path__ + "img/marker-icon-iot-offline.95a04db1.png";